<div class="ratings-row">
  <div class="review-rating-wrapper">
    <div class="rating-icon review" (click)="rate(1)">
      <curbnturf-site-svgs [type]="getStars(1)"></curbnturf-site-svgs>
    </div>
    <div class="rating-icon review" (click)="rate(2)">
      <curbnturf-site-svgs [type]="getStars(2)"></curbnturf-site-svgs>
    </div>
    <div class="rating-icon review" (click)="rate(3)">
      <curbnturf-site-svgs [type]="getStars(3)"></curbnturf-site-svgs>
    </div>
    <div class="rating-icon review" (click)="rate(4)">
      <curbnturf-site-svgs [type]="getStars(4)"></curbnturf-site-svgs>
    </div>
    <div class="rating-icon review" (click)="rate(5)">
      <curbnturf-site-svgs [type]="getStars(5)"></curbnturf-site-svgs>
    </div>
  </div>
</div>
